Backbone = require 'backbone'
Backbone.$ = $
SupportUserSignInTemplate = require('../../user_sign_in.html.mustache')

class SupportUserSignInView extends Backbone.View
  initialize: (options) ->
    @options = options || {}
    @template = SupportUserSignInTemplate

  events:
    'click #my-account-sign-in': 'redirectToLoginFromMyAccount'
    'click #my-order-sign-in' : 'redirectToLoginFromMyOrder'

  render: ->
    @$el.html toHtml(@template, @options , @I18nScope)

  redirectToLoginFromMyAccount: ->
    refUrl = "#{window.SUPPORTBASEURL}?flow=my_account"
    window.location.href = "/login?ref=#{encodeURIComponent(refUrl)}"

  redirectToLoginFromMyOrder: ->
    refUrl = "#{window.SUPPORTBASEURL}?flow=my_order"
    window.location.href = "/login?ref=#{encodeURIComponent(refUrl)}"

module.exports = SupportUserSignInView
